
const { ccclass, menu, property, executeInEditMode, inspector, requireComponent } = cc._decorator;

const BlendFunc = cc['BlendFunc']

@ccclass
@menu('custom/MaskSpriteCircle')
@executeInEditMode
export default class MaskSpriteCircle extends cc.Sprite {

    @property({
        type: cc.Float,
        visible: true,
    })
    set factor(val){
        this._factor = val
        this._updateMaterial()
    }
    get factor(){
        return this._factor
    }

    @property({
        type: cc.Float,
        visible: true,
    })
    set radius(val){
        this._radius = val
        this._updateMaterial()
    }
    get radius(){
        return this._radius
    }


    @property
    protected _factor: number = 0

    @property
    protected _radius: number = 0


    _updateMaterial () {        
        let spriteFrame: cc.SpriteFrame = this['_spriteFrame'];
        // If spriteframe not loaded, disable render and return.
        if (!spriteFrame || !spriteFrame.textureLoaded()) {
            this['disableRender']();
            return;
        }
        
        // make sure material is belong to self.
        let material = this.getMaterials()[0];
        if (!material) {
            this['disableRender']();
            return;
        }
        let tex = spriteFrame.getTexture()
        let rect: cc.Rect = spriteFrame.getRect()  
        material['setProperty']('textureRect', new cc.Vec4(rect.x / tex.width, rect.y / tex.height, rect.width / tex.width, rect.height / tex.height));
        material['setProperty']('textureSize', new cc.Vec2(this.node.width, this.node.height));
        material['setProperty']('factor', this._factor);
        material['setProperty']('radius', this._radius);

        super['_updateMaterial']()
    }
}